import Message from 'actions/message';

export default Message.createReducer();